import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-error-state',
  templateUrl: './error-state.component.html',
  styleUrls: ['./error-state.component.css']
})
export class ErrorStateComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
